import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { WsProvider } from './auth/WsProvider';
import './styles/styles.css';
import './styles/login.css';
import './styles/student-detail.css';
import './styles/student-edit.css';
import './styles/settings.css';
import './styles/years.css';
import './styles/admin.css';
import './styles/staff.css';
import './styles/classes.css';
import './styles/timetable.css';
import './styles/subjects.css';
import './styles/schedule.css';
import './styles/journal.css';
import './styles/grading.css';
import './styles/extras.css';
import './styles/reports.css';
import './styles/broadcasts.css';
// Мобильная адаптация — импортируется ПОСЛЕДНЕЙ, чтобы переопределять
// десктопные правила без !important.
import './styles/responsive.css';

// Заголовок вкладки берём из settings.org.site_title через публичный
// /api/branding. В прод-режиме подстановка идёт в public/index.php
// (заменяет `{{SITE_TITLE}}` в собранном index.html), но в dev Vite
// отдаёт frontend/index.html напрямую — там дефолт «Школьная CRM»,
// а актуальное имя дозаписываем отсюда.
fetch('/api/branding', { credentials: 'include' })
  .then((r) => r.ok ? r.json() : null)
  .then((d) => { if (d?.siteTitle) document.title = d.siteTitle; })
  .catch(() => { /* фолбэк — оставляем дефолт из index.html */ });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WsProvider>
          <App />
        </WsProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
